module.exports = __webpack_public_path__ + "assets/RetinaNarr-BoldItalic.e1d2721b4b709bffabcd72cd7fde7495.woff2";